module.exports = __webpack_public_path__ + "static/media/cars_48.c907f59b.png";